import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ICONS from '../../assets/icons'
import { getNotificationsList } from '../../redux/customerInfo/actions'
import {getFixedLineNotificationsList}from '../../redux/fixedLineCustomerInfo/actions'
import { onMessageListener } from '../../utils/fireBaseMessagingConfig'
import routingMappingDic from '../search/routingDictionary'
import searchDictionary from '../search/searchDictionary.json'
import './customerNotification.scss'

const CustomNotification = ({
  openUpdateDialogCallBack,
  updatePageDueNotificationCallBack,
  callNotificationEventCallBack,
  setRouteIdCallBack,
  getPagesNotAllowedUserToNavigateCallBack,
}) => {
  const dispatch = useDispatch()
  const {
    Language: { selectedLanguage },
    Mode,
    CustomerInfoData: { customerInfo },
  } = useSelector((state) => state)
  const [notification, setNotification] = useState({
    title: '',
    body: '',
    routeId: '',
  })
  const isNotifShown = useRef(false)
  const customerType = JSON.parse(localStorage.getItem('customerType'))

  function ToastDisplay() {
    return (
      <div
        className={`customer-notification-text-container customer-notification-text-container-${Mode.selectedMode}`}>
        <p>{notification?.title}</p>
      </div>
    )
  }

  useEffect(() => {
    if (notification?.title && !isNotifShown.current) {
      isNotifShown.current = true
      toast.info(<ToastDisplay />, {
        position: selectedLanguage === 'AR' ? 'top-left' : 'top-right',
      })
    }
  }, [notification, selectedLanguage])

  const getPageInfo = () => {
    const pagePath = window.location.hash.replace('#', '')
    const pageInfo = searchDictionary.filter(
      (item) => item.routePath === pagePath
    )
    return {
      routeId: pageInfo[0]?.routeID,
      refreshIDs: pageInfo[0]?.refreshIDs,
    }
  }
  const checkIsUserSwitchAccount = () => {
    return customerInfo?.result?.msisdn !== localStorage.getItem('mainNumber')
  }
  onMessageListener()
    .then((payload) => {
      isNotifShown.current = false
      setNotification({
        title: payload?.notification?.title,
        body: payload?.notification?.body,
        routeId: payload?.data?.routeId,
      })
      if(customerType === 1 || customerType === 2){
        getFixedLineNotificationsList(dispatch)
      }else{
        getNotificationsList(dispatch)
      }
      callNotificationEventCallBack(
        'notificationReceive',
        payload?.notification?.body
      )
      const { routeId, refreshIDs } = getPageInfo()
      setRouteIdCallBack(parseInt(payload?.data?.routeId))
      if (
        routeId === parseInt(payload?.data?.routeId) ||
        (refreshIDs && refreshIDs.includes(parseInt(payload?.data?.routeId)))
      ) {
        setRouteIdCallBack(routeId)
        openUpdateDialogCallBack(true)
      }
    })
    .catch((err) => console.log('failed: ', err))
  const onNotificationClick = (chosenRouteId) => {
    callNotificationEventCallBack()
    const { routeId, refreshIDs } = getPageInfo()
    const isUserSwitchAccount = checkIsUserSwitchAccount()
    if (
      routeId === parseInt(chosenRouteId) ||
      (refreshIDs && refreshIDs.includes(parseInt(chosenRouteId))) ||
      isUserSwitchAccount
    ) {
      openUpdateDialogCallBack('onClick', isUserSwitchAccount)
      updatePageDueNotificationCallBack(isUserSwitchAccount)
    } else {
      let pagesCantNavigate = getPagesNotAllowedUserToNavigateCallBack()
      let isUserNotAllowedToNavigate =
        pagesCantNavigate.filter(
          (navigateId) => navigateId === parseInt(chosenRouteId)
        ).length > 0
      callNotificationEventCallBack('notificationRead', notification.body)
      window.location.assign(
        `/#${
          routingMappingDic[parseInt(chosenRouteId)] &&
          chosenRouteId &&
          !isUserNotAllowedToNavigate
            ? routingMappingDic[parseInt(chosenRouteId)]
            : routingMappingDic[49000]
        }`
      )
    }
  }
  const CloseButton = ({ closeToast }) => (
    <img
      src={ICONS[`${Mode.selectedMode}MenuClose`]}
      alt="closeNotificationIcon"
      onClick={(e) => {
        e.stopPropagation()
        closeToast()
      }}
    />
  )
  return (
    <div
      onClick={() => onNotificationClick(notification.routeId)}
      className={`customer-notification-container customer-notification-container-${Mode.selectedMode} ${Mode.selectedMode}`}>
      <ToastContainer
        autoClose={10000}
        closeButton={CloseButton}
        newestOnTop={false}
        closeOnClick
        rtl={selectedLanguage === 'AR' ? true : false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
      />
    </div>
  )
}
export default CustomNotification
